import React from 'react';
import Helmet from 'react-helmet';
import PageHeader from 'components/common/PageHeader';
import Investment from './investment/Investment';
import HeroSection from './HeroSection/HeroSection';
import AdminMessage from './AdminMessage/AdminMessage';
import ContactUs from './ContactUs/ContactUs';
import HeroImagesScrollerMain from './HeroImagesScroller/HeroImagesScrollerMain';

export default function Landing() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Settings | Landing</title>
      </Helmet>
      <PageHeader title="Landing Settings" className="mb-3"></PageHeader>
      <Investment />
      {/* <AdminMessage/> */}
      <ContactUs/>
      <HeroSection />
      <HeroImagesScrollerMain/>
    </>
  );
}
